export const enum RoutesPathList {
  Landing = "/",
  POSLogin = "/pos/login",
  SNSLogin = "/pos/login-sns",
  About = "/about",
  Contact = "/contact",
  Login = "/login",
  Register = "/register",
  Dashboard = "/dashboard",
  Accounting = "/accounting",
  Faq = "/faq",
  Solutions = "/solutions",
  Invoicing = "/invoicing",
  Payroll = "/payroll",
  OrganizationDashboard = "/organization-dashboard",
  ForgotPassword = "/forgot-password",
  OrganizationUserProfile = "/organization-user-profile",
  OrganizationUserPassword = "/organization-user-password",
  BankSettings = "/bank-settings",
  Exchange = "/exchange",
  Transactions = "/transactions",
  Settings = "/settings",
  Groups = "/groups",
  Blog = "/blog",
  ChangePassword = "/change-password",
  ComingSoon = "/coming-soon",
  RESET_PASSWORD = "/reset-password",
  NewClientPOS = "/pos/new-client-pos",
  NewClientSNS = "/pos/new-client-pos-sns",
  ExchangePhone = "/pos/exchange-phone",
  ExchangeSNS = "/pos/exchange-phone-sns",
  WaintingApproval = "/pos/waiting-approval",
  WaintingApprovalSNS = "/pos/waiting-approval-sns",
  ExchangeSuccess = "/pos/exchange-success",
  ExchangeSNSSuccess = "/pos/exchange-success-sns",
  ReceiptPOS = "/pos/receipt-pos",
  ReceiptSNS = "/pos/receipt-pos-sns",
  ScanWallet = "/pos/scan-wallet",
  ScanWalletSNS = "/pos/scan-wallet-sns",
  ExchangeNotApproved = "/pos/exchange-not-approved",
  ExchangeNotApprovedSNS = "/pos/exchange-not-approved-sns",
  TransactionApproved = "/pos/transaction-approved",
  TransactionApprovedSNS = "/pos/transaction-approved-sns",
  ScanIDPOS = "/pos/scanidpos",
  ScanIDSNS = "/pos/scanidpos-sns",
  FormPOS = "/pos/formpos",
  FormSNS = "/pos/formpos-sns",
  ActivateSuccess = "/success",
  KYC = "/pos/kyc",
  KYCPOS = "/pos/kyc-sns",
  TOU = "/tou",
  WPP = "/wpp",
}

export const Routes = [
  {
    isProtected: false,
    component: "Landing",
    route: RoutesPathList.Landing,
  },
  {
    isProtected: false,
    component: "Blog",
    route: RoutesPathList.Blog,
  },
  {
    isProtectted: false,
    component: "ToU",
    route: RoutesPathList.TOU,
  },
  {
    isProtected: false,
    component: "WPP",
    route: RoutesPathList.WPP,
  },
  {
    isProtected: false,
    component: "About",
    route: RoutesPathList.About,
  },
  {
    isProtected: false,
    component: "Contact",
    route: RoutesPathList.Contact,
  },
  {
    isProtected: false,
    component: "Login",
    route: RoutesPathList.Login,
  },
  {
    isProtected: false,
    component: "Register",
    route: RoutesPathList.Register,
  },
  {
    isProtected: false,
    component: "Accounting",
    route: RoutesPathList.Accounting,
  },
  {
    isProtected: false,
    component: "Invoicing",
    route: RoutesPathList.Invoicing,
  },
  {
    isProtected: false,
    component: "Payroll",
    route: RoutesPathList.Payroll,
  },
  {
    isProtected: true,
    component: "Organizations",
    route: RoutesPathList.OrganizationDashboard,
  },
  {
    isProtected: true,
    component: "NewClientPOS",
    route: RoutesPathList.NewClientPOS,
  },
  {
    isProtected: false,
    component: "ForgotPassword",
    route: RoutesPathList.ForgotPassword,
  },
  {
    isProtected: false,
    component: "ForgotPassword",
    route: RoutesPathList.Groups,
  },
  {
    isProtected: true,
    component: "OrganizationUserProfile",
    route: RoutesPathList.OrganizationUserProfile,
  },
  {
    isProtected: true,
    component: "OrganizationUserPassword",
    route: RoutesPathList.OrganizationUserPassword,
  },
  {
    isProtected: true,
    component: "BankSettings",
    route: RoutesPathList.BankSettings,
  },
  {
    isProtected: true,
    component: "Exchange",
    route: RoutesPathList.Exchange,
  },
  {
    isProtected: true,
    component: "Transactions",
    route: RoutesPathList.Transactions,
  },
  {
    isProtected: true,
    component: "Settings",
    route: RoutesPathList.Settings,
  },
  {
    isProtected: true,
    component: "Blog",
    route: RoutesPathList.Blog,
  },
  {
    isProtected: true,
    component: "ChangePassword",
    route: RoutesPathList.ChangePassword,
  },
  {
    isProtected: false,
    component: "ComingSoon",
    route: RoutesPathList.ComingSoon,
  },
  {
    isProtected: false,
    component: "RESET_PASSWORD",
    route: RoutesPathList.RESET_PASSWORD,
  },
];
